import { CurrentStateLog } from './CurrentStateLog';
import { User } from "./User";

export class StateLog {
    orderId: number = 0;
    currentStateId: number = 0;
    previousStateId?: number;
    lastUpdateByUserId?: number;
    lastUpdateByUser?: User;
    createdAt: Date = new Date();
    currentStateName: string;
    currentState?: CurrentStateLog;
}